import profile from '../../fields/other/profile';

export const MUTATION_CANCEL_ABO = /* GraphQL */ `
	mutation($cancelUpdate: AbonnementCancelUpdate, $id: String!) {
		cancelAbo(cancelUpdate: $cancelUpdate, id: $id) {
			${profile}
		}
	}
`;
